<template>
  <section class="section">
    <button
      class="button cashboxbutton tooltip"
      :class="openbox ? 'is-link' : 'is-danger'"
      v-show="hasBoxOfCash"
      data-tooltip="Cudre Caja"
      @click="clicktocashbox"
    >
      <span class="icon">
        <i class="material-icons">point_of_sale</i>
      </span>
    </button>
    <div class="container">
      <h1 class="title">
        {{ empresa.nombrec }}
        <small class="title is-5"
          >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
        >
        <small class="subtitle is-7">{{ empresa.nombre }}</small>
      </h1>
      <div v-show="errorpreferences" class="notification is-danger">
        <h1 class="title is-4">
          ¡Antes de continuar debe configurar las preferencias!
        </h1>
        <h1 class="subtitle is-5">
          Este módulo necesita la congiguración de la cuenta de caja, de la
          forma en que imprimira los documentos y si requiere ver el cambio en
          la impresion de la factura.
        </h1>
        <router-link
          :to="{ name: 'settings.pventa' }"
          class="button is-danger is-outlined is-inverted is-medium"
          >Ir a Preferencias</router-link
        >
      </div>
      <div class="columns">
        <div class="column">
          <div class="field is-fullwidth has-addons">
            <div class="control">
              <a class="button is-light" @click="launchModal">
                <span class="icon">
                  <i class="material-icons">list_alt</i>
                </span>
              </a>
            </div>
            <div class="control is-expanded has-icons-left">
              <input
                id="c1"
                @blur="blurFunction('c1')"
                @keydown="keyfunction($event, 'c1')"
                @focus="focusfunction('c1')"
                class="input is-fullwidth"
                type="text"
                v-model="textInputs.c1"
                placeholder="Comprobante"
                autocomplete="off"
              />
              <span v-show="editsel" class="icon is-small is-left">
                <i class="material-icons">edit</i>
              </span>
              <span v-show="!editsel" class="icon is-small is-left">
                <i class="material-icons">control_camera</i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <fieldset :disabled="true">
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  v-model="textInputs.c2"
                  type="text"
                  placeholder="Documento"
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div class="column">
          <div class="field is-fullwidth has-addons">
            <p class="control is-expanded">
              <input
                class="input"
                id="c3"
                @blur="blurFunction('c3')"
                @keydown="keyfunction($event, 'c3')"
                type="number"
                placeholder="Fecha"
                v-model="textInputs.c3"
                :disabled="!editday"
              />
            </p>
            <p class="control">
              <a class="button is-static">{{
                comundata.periodo ? comundata.periodo : "xx" | periodo()
              }}</a>
            </p>
          </div>
        </div>
      </div>
      <div class="columns" v-if="isNCElect">
        <div class="column">
          <strong>Seleccione un documento referencia</strong>
          <div class="field is-grouped is-grouped-multiline">
            <div class="control">
              <div class="select">
                <select name="country" v-model="ncdata.comprobante">
                  <option
                    v-for="option in comprobanteNC"
                    v-bind:value="option"
                    v-bind:key="option._id"
                  >
                    {{ option.codigo }} {{ option.nombre }}
                  </option>
                </select>
              </div>
            </div>
            <div class="control">
              <div class="select">
                <select v-model="ncdata.mes">
                  <option
                    v-for="(option, key) in meses"
                    v-bind:value="option"
                    v-bind:key="key"
                  >
                    {{ option.codigo }}
                  </option>
                </select>
              </div>
            </div>
            <p class="control">
              <input
                class="input"
                type="number"
                placeholder="Documento"
                v-model="ncdata.documento"
              />
            </p>
            <p class="control">
              <button class="button is-link" @click="buscarDocumento">
                <span class="icon is-medium">
                  <i class="material-icons">search</i> </span
                >&nbsp; Buscar
              </button>
            </p>
            <div class="control" v-if="ncOrNd === 'NC'">
              <div class="select">
                <select v-model="ncdata.responsecode">
                  <option value="1">Devolución de parte de los bienes</option>
                  <option value="2">Anulación de factura electrónica</option>
                  <option value="3">Rebaja total aplicada</option>
                  <option value="4">Descuento total aplicado</option>
                  <option value="5">
                    Rescisión: nulidad por falta de requisitos
                  </option>
                  <option value="6">Otros</option>
                </select>
              </div>
            </div>
            <div class="control" v-if="ncOrNd === 'ND'">
              <div class="select">
                <select v-model="ncdata.responsecode">
                  <option value="1">Intereses</option>
                  <option value="2">Gastos por cobrar</option>
                  <option value="3">Cambio de valor</option>
                  <option value="4">Otros</option>
                </select>
              </div>
            </div>
          </div>
          <div class="notification" v-show="documentos.length > 0">
            <span v-if="ncdata.comprobante">{{
              ncdata.comprobante.codigo
            }}</span>
            <span v-if="ncdata.comprobante">{{
              ncdata.comprobante.nombre
            }}</span>
            periodo
            <span v-if="ncdata.mes">{{ ncdata.mes.codigo | periodo() }}</span
            >, documentos generados
            <strong>{{ documentos.length }}</strong>
            del {{ documentos[0] | number(0) }} al
            {{ documentos[documentos.length - 1] | number(0) }}
          </div>
          <div
            class="notification is-link fontMono"
            v-show="dataNC.fraelect.cufe"
          >
            <strong>Los datos del documento referencia</strong><br />
            <strong>CUFE: </strong>{{ dataNC.fraelect.cufe }} <br />
            <strong>Fecha: </strong><span>{{ dataNC.fecha }}</span>
            <strong>Docuemtno:</strong> {{ dataNC.fraelect.prefijo
            }}{{ dataNC.fraelect.documento }}
          </div>
        </div>
      </div>
      <div v-show="existborrador" class="columns">
        <div class="column">
          <div class="notification is-link">
            <h1 class="title">Existe un borrador</h1>
            <h1 class="subtitle">
              Existe un borrador que no ha sido guardado, ¿desea cargarlo?
            </h1>
            <button
              class="button is-info is-inverted is-outlined is-large"
              @click="cargarborrador"
            >
              Si
            </button>
            <button
              class="button is-info is-inverted is-outlined is-large"
              @click="(existborrador = false), (borrador = null)"
            >
              No
            </button>
            <button
              class="button is-info is-inverted is-outlined is-large"
              @click="eliminarborrador"
            >
              Eliminar borrador
            </button>
          </div>
        </div>
      </div>
      <div v-if="!comundata.comprobante" class="columns">
        <div class="column">
          <div class="notification">
            <h1 class="title">yungol es ágil y fácil de usar.</h1>
            <h2 class="subtitle">
              <br />Te recomendamos utilizar estos atajos para navegar más
              rápido en nuestro sistema.
            </h2>
            <div class="content">
              <ul>
                <li>
                  <strong>F3</strong> Con esta tecla puedes desplegar el menú
                  con las opciones. O puedes dar clic directamente en este icono
                  <span class="icon">
                    <i class="material-icons icon-lista">list_alt</i>
                  </span>
                </li>
                <li>
                  <strong>F2</strong> Con esta tecla puedes editar los textos en
                  la celda actual.
                </li>
                <li>
                  <span class="icon">
                    <i class="material-icons">keyboard_return</i>
                  </span>
                  Con enter puedes desplazarte rápidamente hacia la columna
                  siguiente, también puedes hacerlo con las flechas del teclado.
                </li>
                <li>
                  <strong>F10</strong>
                  Con esta tecla puedes guardar rápidamenten el documento.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="comundata.comprobante" class="columns">
        <div class="column">
          <div class="notification" :class="classfila(-1)">
            <div class="etiqutaE">Encabezado</div>
            <y-itemsview
              :items="itemsencabezado"
              :columna="columna"
              :filaactual="-1"
              :fila="fila"
              @fila="changeFila"
              @columna="changeColumna"
            ></y-itemsview>
            <y-itemsform
              style="margin-top: 30px"
              v-if="fila === -1"
              :namevariable="'itemsencabezado'"
              :items="itemsencabezado"
              @changeinput="changeinput"
              @keyfunctionitem="keyitem"
              :columna="columna"
              @columna="changeColumna"
              @fila="changeFila"
              :fila="fila"
              @f3="f3"
              :cambio="cambio"
            ></y-itemsform>
          </div>
          <div
            class="notification"
            v-for="(rg, index) in productosfactura"
            :key="index"
            :class="classfila(index)"
          >
            <div class="etiqutaR">{{ index + 1 }}</div>
            <y-itemsview2
              :items="rg.items"
              :columna="columna"
              :filaactual="index"
              :fila="fila"
              @fila="changeFila"
              @columna="changeColumna"
              :reg="rg"
            ></y-itemsview2>
            <y-itemsform
              style="margin-top: 30px"
              v-if="fila === index"
              :namevariable="index"
              :items="rg.items"
              @changeinput="changeinputreg"
              @keyfunctionitem="keyitem"
              :columna="columna"
              @columna="changeColumna"
              @fila="changeFila"
              :fila="fila"
              @f3="f3"
              :cambio="cambio"
              :lengthReg="productosfactura.length"
              @newReg="addReg"
              @deleteReg="deleteReg"
              @llegofinal="llegofinalregistros"
            ></y-itemsform>
          </div>
          <div class="notification is-total has-background-grey-light">
            <div class="columns is-gapless">
              <div class="column is-10">
                <div class="datospruducto">
                  <table cellspacing="0" style="width: 100%">
                    <tr>
                      <td style="width: 15%">
                        <strong>Total</strong>
                      </td>
                      <td style="width: 25%">
                        <div style="float: left">
                          <span>Bruto</span>
                        </div>
                        <div
                          style="float: right"
                          class="fontMono has-text-right"
                        >
                          <span>{{ total.subtotal | number(2) }}</span>
                        </div>
                      </td>
                      <td style="width: 5%"></td>
                      <td style="width: 25%">
                        <div style="float: left">
                          <span>Descuento:</span>
                        </div>
                        <div
                          style="float: right"
                          class="fontMono has-text-right"
                        >
                          <span>{{ total.descuento | number(2) }}</span>
                        </div>
                      </td>
                      <td style="width: 5%"></td>
                      <td style="width: 25%">
                        <div style="float: left">Iva:</div>
                        <div
                          style="float: right"
                          class="fontMono has-text-right"
                        >
                          {{ total.iva | number(2) }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="column fontMono has-text-right has-text-white">
                {{ total.total | number(2) }}
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="notification">
                <div class="columns is-gapless">
                  <div class="column">{{ contrapartida.nombre }}</div>
                  <div class="column fontMono has-text-right">
                    {{ totalcontrapartida | number(2) }}
                  </div>
                </div>
              </div>
              <div
                class="notification hand"
                v-for="(contrapartida, index) in totalesfactura"
                :key="index"
                @click="selDatatotal(index)"
                :class="activetotal(index)"
              >
                <div class="columns is-gapless">
                  <div class="column">{{ contrapartida.nombre }}</div>
                  <div class="column fontMono has-text-right">
                    {{ contrapartida.valor | number(2) }}
                  </div>
                </div>
                <y-formregistrototal
                  v-if="showInputtotal(index)"
                  @f10guardar="f10guardar"
                  :lengthRegtotal="totalesfactura.length"
                  :lengthReg="productosfactura.length"
                  :filatotal="filatotal"
                  :fila="fila"
                  @fila="changeFila"
                  @filatotal="changeFilatotal"
                  @changeInputRegtotal="changeDatatotal"
                  :reg="totalesfactura"
                ></y-formregistrototal>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <div class="control">
                  <textarea
                    v-model="textoFactura"
                    class="textarea"
                    placeholder="Texto personalizado del documento"
                    rows="2"
                  ></textarea>
                </div>
              </div>
              <div class="buttons">
                <button
                  class="button is-primary is-medium"
                  id="botonGuardar"
                  @click="f10guardar"
                >
                  <span class="icon is-medium">
                    <i class="material-icons">save</i> </span
                  >&nbsp; Guardar F10
                </button>
                <button
                  class="button is-light is-medium"
                  v-show="!turno._id"
                  @click="saveandprint"
                >
                  <span class="icon is-medium">
                    <i class="material-icons">print</i> </span
                  >&nbsp; Guardar e Imprimir
                </button>
                <button class="button is-warning is-medium" @click="cancelar">
                  <span class="icon is-medium">
                    <i class="material-icons">cancel</i> </span
                  >&nbsp; Cancelar
                </button>
              </div>
            </div>
          </div>
          <y-modalcashback
            :show="showmodalcash"
            :datamodalcashback="datamodalcashback"
            @showmodalcashback="showmodalcashback"
            @responsemodalcashback="responsemodalcashback"
          ></y-modalcashback>
        </div>
      </div>
    </div>
    <y-modalcashbox
      :show="showmodalcashbox"
      @closemodal="clicktocashbox"
      :turno="turno"
      @resultturno="resultturno"
    ></y-modalcashbox>
    <div v-show="false">
      <y-printfrapvta
        v-if="
          dataprint.registros[0].valor &&
          dataprint.comprobante.estructura === 'factura' &&
          encabezadoFactura.preferences.impresora === '0'
        "
        id="printfra"
        :dataprint="dataprint"
      ></y-printfrapvta>
      <y-printfrapvtastrip
        v-if="
          dataprint.registros[0].valor &&
          dataprint.comprobante.estructura === 'factura' &&
          encabezadoFactura.preferences.impresora === '1'
        "
        id="printfra"
        :dataprint="dataprint"
      ></y-printfrapvtastrip>
      <y-printfrapvtastrip80
        v-if="
          dataprint.registros[0].valor &&
          dataprint.comprobante.estructura === 'factura' &&
          encabezadoFactura.preferences.impresora === '2'
        "
        id="printfra"
        :dataprint="dataprint"
      ></y-printfrapvtastrip80>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import functions from "@/helpers/functions";
import apiServices from "@/services/yungol-services";
import yItemsform from "@/components/facturar/componentsfra/Formitems.vue";
import yItemsview from "@/components/facturar/componentsfra/Viewitems.vue";
import yItemsview2 from "@/components/facturar/componentsfra/Viewitems2.vue";
import yFormregistrototal from "@/components/registrar/Formregistrototal2.vue";
import yModalcashback from "@/components/modals/Modalcashback.vue";
import yModalcashbox from "@/components/modals/Modalcashbox.vue";
import yPrintfrapvta from "@/components/prints/Frapvta.vue";
import yPrintfrapvtastrip from "@/components/prints/Frapvtastrip.vue";
import yPrintfrapvtastrip80 from "@/components/prints/Frapvtastrip80.vue";

function getSum1(t, k, v, arr) {
  t.subtotal = parseInt(t.subtotal) + parseInt(k.valor);
  t.iva = parseInt(t.iva) + parseInt((k.valor * k.datosFactura.impuesto) / 100);
  t.total =
    parseInt(t.total) +
    parseInt(k.valor) +
    parseInt((k.valor * k.datosFactura.impuesto) / 100);
  return t;
}

function sumarDias(fecha, dias) {
  fecha.setDate(fecha.getDate() + dias);
  return fecha;
}

export default {
  data() {
    return {
      documentos: [],
      meses: [],
      ncdata: {
        comprobante: "",
        mes: "",
        documento: "",
        responsecode: 2,
      },
      dataNC: {
        fecha: "",
        fraelect: {},
      },
      dataprint: {
        totales: {
          subtotal: 0,
          iva: 0,
          total: 0,
        },
        empresa: {
          nit: "",
          nombrec: "",
          nombre: "",
          ciudad: "",
          direccion: "",
          telefono: "",
        },
        vencimiento: "2020-07-30T05:00:00.000Z",
        incluircambio: false,
        comprobante: {
          t1: "",
          t2: "",
          titulo: "",
          nombre: "",
          prefijo: "",
          caracteres: "",
          factura: {
            resolucion: "",
            piefactura: "",
            negrita: "",
            mensajefinal: "",
          },
        },
        contrapartidas: [
          {
            nombrepers: "",
          },
        ],
        contrapartida: {
          valor: 0,
          idcuenta: {
            nombre: "",
          },
        },
        registros: [
          {
            documento: 0,
            cantidad: 0,
            descuento: 0,
            vlrUnitario: 0,
            valor: 0,
            fecha: "2020-07-30T05:00:00.000Z",
            producto: {
              codigo: "",
              descripcion: "",
            },
            datosFactura: {
              texto: "",
              impuesto: 0,
              cambio: 0,
            },
            idnit: {
              nombre: "",
              codigo: "",
              direccion: "",
              ciudad: "",
              telefono: "",
              correo: "",
              fecha: "2020-07-30T05:00:00.000Z",
            },
          },
        ],
      },
      textoFactura: "",
      filatotal: 0,
      showmodalcash: false,
      datamodalcashback: {
        name: "Contrapartida",
        valor: 0,
      },
      turno: {},
      youcansave: true,
      guardando: false,
      cambio: 0,
      itemsencabezado: [
        {
          cod: "nit",
          nombre: "Cliente",
          bd: "idnit",
          tiene: "tNit",
          valida: "cumpleNit",
          css: { status: "normal", size: "normal" }, // sirve para poner de color el boton warning o danger o light tambien si es small o large
          texto: "nombreNit",
          input: "N/A",
          inputrich: null,
          inputid: null,
        },
        {
          cod: "cotizacion",
          nombre: "Cotización",
          bd: "cotizacion",
          tiene: "tCotizacion",
          valida: "cumpleCotizacion",
          css: { status: "normal", size: "normal" },
          texto: "nombrecotizacion",
          input: "Sin cotización",
          inputrich: null,
          inputid: null,
        },
        {
          cod: "nvendedor",
          nombre: "Vendedor",
          bd: "vendedor",
          tiene: "tVendedor",
          valida: "cumpleVendedor",
          css: { status: "normal", size: "normal" },
          texto: "nombrevendedor",
          input: "hola",
          inputrich: null,
          inputid: null,
        },
        {
          cod: "fpago",
          nombre: "Forma de pago",
          bd: "fpago",
          tiene: "tfpago",
          valida: "cumpleFpago",
          css: { status: "normal", size: "normal" },
          texto: "nombrefpago",
          input: "mundo",
          inputrich: null,
          inputid: null,
        },
        {
          cod: "lprecios",
          nombre: "Lista Precios",
          bd: "lprecios",
          tiene: "tlprecios",
          valida: "cumpleLprecios",
          css: { status: "normal", size: "normal" },
          texto: "nombrelprecios",
          input: "cosa",
          inputrich: null,
          inputid: null,
        },
        {
          cod: "nccostos",
          nombre: "C Costos",
          bd: "ccostos",
          tiene: "tCcosto",
          valida: "cumpleCcosto",
          css: { status: "normal", size: "normal" },
          texto: "nombreCcostos",
          input: "rara",
          inputrich: null,
          inputid: null,
        },
        {
          cod: "orderreference",
          nombre: "Orden de Compra",
          bd: "orderreference",
          tiene: "tOrderreference",
          valida: "cumpleOrderreference",
          css: { status: "normal", size: "normal" },
          texto: "nombreOrderreference",
          input: "rara",
          inputrich: null,
          inputid: null,
        },
      ],
      fila: -1,
      columna: 1,
      totalesfactura: [],
      productosfactura: [],
      contrapartida: {},
      borrador: null,
      existborrador: false,
      registros: [],
      encabezadoFactura: {
        idnit: "",
        nit: "",
        nombreNit: "",
        nvendedor: "",
        nccostos: "",
        ccostos: "",
        nombrebodega: "",
        nombrevendedor: "",
        nombreCcostos: "",
        nlprecios: "",
        fpago: "",
        nombrelprecios: "",
        nombrefpago: "",
        cumpleCcosto: true,
        cumpleNit: true,
        cumpleVendedor: true,
        cumpleLprecios: true,
        cumpleBodega: true,
        cumpleFpago: true,
        preferences: {
          cuenta: "",
          impresora: "0",
          incluircambio: "0",
        },
        vencimientos: [
          {
            codigo: 0,
            nombre: "Contado",
          },
          {
            codigo: 7,
            nombre: "7 Días",
          },
          {
            codigo: 15,
            nombre: "15 Días",
          },
          {
            codigo: 30,
            nombre: "30 Días",
          },
          {
            codigo: 45,
            nombre: "45 Días",
          },
          {
            codigo: 60,
            nombre: "60 Días",
          },
          {
            codigo: 75,
            nombre: "75 Días",
          },
          {
            codigo: 90,
            nombre: "90 Días",
          },
        ],
      },
      usermongo: null,
      editsel: false,
      editday: true,
      comprobanteModal: [],
      comprobanteNC: [],
      comprobantes: [],
      openbox: false,
      showmodalcashbox: false,
      errorpreferences: false,
      textInputs: {
        c1: "",
        c2: null,
        c3: null,
      },
      comundata: {
        comprobante: null,
        numDoc: null,
        dia: null,
        periodo: null,
        ccostos: null,
      },
    };
  },
  computed: {
    ...mapState([
      "user",
      "empresa",
      "resultDatamodal",
      "cuentas",
      "nits",
      "vendedores",
      "productos",
      "bodegas",
    ]),
    compperiodo() {
      if (this.ncdata.comprobante && this.ncdata.mes) {
        return {
          comprobante: this.ncdata.comprobante,
          periodo: this.ncdata.mes,
        };
      } else {
        return false;
      }
    },
    ncOrNd() {
      let returned = null;
      returned = this.comundata.comprobante.tipodocumento;
      return returned;
    },
    hasBoxOfCash() {
      return (
        this.empresa && this.empresa.modulos && this.empresa.modulos.cuadrecaja
      );
    },
    listas() {
      const _this = this;
      const returned = [];
      const keyslistas = Object.keys(this.empresa.modulos.pventa.listas);
      keyslistas.forEach((e) => {
        returned.push({
          codigo: String(e),
          nombre: _this.empresa.modulos.pventa.listas[e],
        });
      });
      return returned;
    },
    total() {
      const total = this.productosfactura.reduce(
        function (acumulator, current) {
          const cantidad = functions.dosDecimales(current.cantidad);
          const vlrUnitario = functions.dosDecimales(current.vlrUnitario);
          const porcentajedescuento = functions.dosDecimales(current.descuento);
          const subtotal = functions.dosDecimales(cantidad * vlrUnitario);
          const descuento = functions.dosDecimales(
            (subtotal * porcentajedescuento) / 100
          );
          const bruto = functions.dosDecimales(subtotal - descuento);
          const porcentajeiva = current.objetoProducto
            ? functions.dosDecimales(current.objetoProducto.linea.vImpuesto)
            : 0;
          const iva = functions.dosDecimales((bruto * porcentajeiva) / 100);
          acumulator.total += functions.dosDecimales(
            subtotal - descuento + iva
          );
          acumulator.iva += functions.dosDecimales(iva);
          acumulator.descuento += functions.dosDecimales(descuento);
          acumulator.subtotal += functions.dosDecimales(subtotal);
          return acumulator;
        },
        {
          subtotal: 0,
          total: 0,
          iva: 0,
          descuento: 0,
        }
      );
      return total;
    },
    totalcontrapartida() {
      const totalotroscontrapartida = this.totalesfactura.reduce(
        (acumulator, current) => {
          return acumulator + functions.dosDecimales(current.valor);
        },
        0
      );
      return functions.dosDecimales(this.total.total - totalotroscontrapartida);
    },
    isNCElect() {
      if (
        this.comundata.comprobante &&
        (this.comundata.comprobante.tipodocumento === "NC" ||
          this.comundata.comprobante.tipodocumento === "ND") &&
        this.comundata.comprobante.isElectronico
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    cargaregistros(registros) {
      const _this = this;
      const regIngresos = [];
      for (let index in registros) {
        const reg = registros[index];
        if (reg.grupo === "4") {
          regIngresos.push(reg);
        }
      }
      if (regIngresos.length > 0) {
        this.productosfactura = [];
        for (let index1 = 0; index1 < regIngresos.length; index1++) {
          _this.createregproducto(this, false);
        }
        for (let index1 in regIngresos) {
          const reg1 = regIngresos[index1];
          _this.itemsencabezado[0].input = reg1.idnit.codigo;
          _this.itemsencabezado[0].inputrich = reg1.idnit.nombre;
          _this.itemsencabezado[0].inputid = reg1.idnit._id;

          const keysitems = [];
          for (let index2 in this.productosfactura[index1].items) {
            keysitems.push(_this.productosfactura[index1].items[index2].cod);
          }
          const nproducto = keysitems.indexOf("nproducto");
          const ndescripcion = keysitems.indexOf("descripcion");
          const nbodega = keysitems.indexOf("nbodega");
          const nbatch = keysitems.indexOf("batchcodigo");
          const ncantidad = keysitems.indexOf("cantidad");
          const nvlrunit = keysitems.indexOf("vlrUnitario");
          const ndescuento = keysitems.indexOf("descuento");
          _this.textoFactura = reg1.datosFactura.texto
            ? reg1.datosFactura.texto
            : "";
          _this.productosfactura[index1].orden = reg1.orden;
          _this.productosfactura[index1].items[nproducto].input =
            reg1.producto.codigo;
          _this.productosfactura[index1].items[nproducto].inputrich =
            reg1.producto.descripcion;
          _this.productosfactura[index1].items[nproducto].inputid =
            reg1.producto._id;
          if (_this.empresa.modulos.descriptioninvoice) {
            _this.productosfactura[index1].items[ndescripcion].input =
              reg1.descripcion;
          }
          _this.productosfactura[index1].items[nbodega].input =
            reg1.bodega.codigo;
          _this.productosfactura[index1].items[nbodega].inputrich =
            reg1.bodega.descripcion;
          _this.productosfactura[index1].items[nbodega].inputid =
            reg1.bodega._id;
          _this.productosfactura[index1].bodega = reg1.bodega
            ? reg1.bodega._id
            : null;
          if (_this.empresa.lote) {
            _this.productosfactura[index1].items[nbatch].input =
              reg1.batchcodigo;
            _this.productosfactura[index1].items[nbatch].inputrich =
              reg1.batchnombre;
            _this.productosfactura[index1].items[nbatch].inputid =
              reg1.batchcodigo;
          }
          _this.productosfactura[index1].items[ncantidad].input = reg1.cantidad;
          _this.productosfactura[index1].cantidad = functions.dosDecimales(
            reg1.cantidad
          );
          _this.productosfactura[index1].items[nvlrunit].input =
            reg1.vlrUnitario;
          _this.productosfactura[index1].vlrUnitario = functions.dosDecimales(
            reg1.vlrUnitario
          );
          _this.productosfactura[index1].items[ndescuento].input =
            reg1.descuento;
          _this.productosfactura[index1].descuento = functions.dosDecimales(
            reg1.descuento
          );
          _this.fila = index1;
          for (let index3 in this.productosfactura[index1].items) {
            _this.validaregistros(index3);
          }
        }
        this.fila = -1;
        setTimeout(function () {
          _this.productosfactura.sort(
            (a, b) => parseInt(a.orden) - parseInt(b.orden)
          );
          document.getElementById("inputItems").focus();
        }, 5);
      }
    },
    llegofinalregistros() {
      if (this.totalesfactura.length > 0) {
        this.fila = -2;
        this.filatotal = 0;
        setTimeout(function () {
          document.getElementById("inputRegtotal").focus();
        }, 5);
      }
    },
    async traeNits(_this) {
      let result;
      try {
        result = await apiServices.get(`/nits`);
        _this.$store.commit("refreshNits", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los terceros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los terceros", err);
      }
    },
    async traeBodegas(_this) {
      let result;
      try {
        result = await apiServices.get(`/bodegas`);
        _this.$store.commit("refreshBodegas", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando las bodegas.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando las bodegas", err);
      }
    },
    async traeVendedores(_this) {
      let result;
      try {
        result = await apiServices.get(`/vendedores`);
        _this.$store.commit("refreshVendedores", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los vendedores.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los vendedores", err);
      }
    },
    cancelar() {
      let temporal = localStorage.getItem("temporal");
      temporal = JSON.parse(temporal);
      if (temporal) {
        this.existborrador = true;
        this.borrador = temporal;
      } else {
        this.existborrador = false;
        this.borrador = null;
      }
      this.registros = [];
      this.productosfactura = [];
      this.totalesfactura = [];
      this.fila = -1;
      this.columna = 1;
      this.guardando = false;
      this.traeComprobantes(this);
      this.textInputs.c1 = "";
      this.textInputs.c2 = null;
      this.textInputs.c3 = null;
      this.comundata.comprobante = null;
      this.comundata.numDoc = null;
      this.comundata.dia = null;
      this.comundata.periodo = null;
      this.comundata.cuentasdoc = null;
      document.getElementById("c1").focus();
    },
    async findturno() {
      try {
        const result = await apiServices.get(`/turnoactual`);
        if (result.data) {
          this.openbox = true;
          this.turno = result.data;
          this.turno.fecha = functions.formatDate(new Date(this.turno.fecha));
        } else {
          this.openbox = false;
          this.turno = {};
          this.turno.responsable = this.user.displayName;
          this.turno.fecha = functions.formatDate(new Date());
        }
      } catch (err) {
        console.log(err);
      }
    },
    async traeDocumentos(_this, comprobanteId, periodo) {
      let result;
      try {
        result = await apiServices.get(
          `/consulta/doumentos/${comprobanteId}/${periodo}`
        );
        this.documentos = result.data.map((e) => parseInt(e._id.documento));
        this.documentos.sort((a, b) => parseInt(a) - parseInt(b));
      } catch (err) {
        console.log("ocurrio un problema cargando los documentos", err);
      }
    },
    async buscarDocumento() {
      try {
        let result;
        let result2;
        if (
          this.comundata &&
          this.comundata.comprobante &&
          this.comundata.comprobante.isPrueba
        ) {
          result = await apiServices.get(
            `fraelectprueba/${this.ncdata.documento}/${this.ncdata.comprobante.id}/${this.ncdata.mes.year}/${this.ncdata.mes.mes}`
          );
        } else {
          result = await apiServices.get(
            `fraelect/${this.ncdata.documento}/${this.ncdata.comprobante.id}/${this.ncdata.mes.year}/${this.ncdata.mes.mes}`
          );
          result2 = await apiServices.get(
            `mdocumento2/${this.ncdata.comprobante.id}/${this.ncdata.documento}/${this.ncdata.mes.year}/${this.ncdata.mes.mes}`
          );
        }
        const registros = result2.data;
        this.cargaregistros(registros);
        this.dataNC = result.data;
      } catch (err) {
        console.log(err);
      }
    },
    async traeMeses(_this) {
      let result;
      try {
        result = await apiServices.get(`/meses`);
        _this.meses = [];
        _this.meses.push({
          codigo: "Meses",
        });
        let d = [];
        d = functions.order(result.data, "codigo");
        d.forEach((e) => _this.meses.push(e));
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los meses.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los meses", err);
      }
    },
    eliminarborrador() {
      localStorage.removeItem("temporal");
      this.borrador = null;
      this.existborrador = false;
    },
    cargarborrador() {
      this.textInputs.c1 = this.borrador.comprobante.codigo;
      this.textInputs.c3 = this.borrador.dia;
      this.blurFunction("c1");
      this.blurFunction("c3");
      this.existborrador = false;
      setTimeout(function () {
        document.getElementById("inputItems").focus();
      }, 5);
    },
    resultturno(turno) {
      if (turno._id) {
        this.turno = turno;
        this.turno.fecha = functions.formatDate(new Date(this.turno.fecha));
        this.openbox = true;
      } else {
        this.openbox = false;
        this.turno = {};
        this.turno.responsable = this.user.displayName;
        this.turno.fecha = functions.formatDate(new Date());
      }
      this.clicktocashbox();
    },
    convertvalor(text) {
      let number = parseFloat(text);
      if (isNaN(number)) {
        number = 0;
      }
      return number;
    },
    async responsemodalcashback(cashback) {
      try {
        const _this = this;
        if (cashback.status === "print") {
          for (let index in _this.registros) {
            const record = _this.registros[index];
            if (record.grupo === "4") {
              _this.registros[index].datosFactura.cambio = cashback.cashback;
              _this.registros[index].datosFactura.efectivo = cashback.cash;
            }
          }
          this.showmodalcashback();
          const result = await this.saveRecors(_this.registros);
          this.dataprint = await this.transformdatatoprint(result.data);
          setTimeout(function () {
            _this.$print("printfra", {
              name: `${_this.dataprint.comprobante.nombre} - ${_this.dataprint.registros[0].documento} - ${_this.dataprint.registros[0].mes}`,
            });
            _this.notifyguardado({ guardo: true });
          }, 100);
        } else if (cashback.status === "save") {
          for (let index in _this.registros) {
            const record = _this.registros[index];
            if (record.grupo === "4") {
              _this.registros[index].datosFactura.cambio = cashback.cashback;
              _this.registros[index].datosFactura.efectivo = cashback.cash;
            }
          }
          this.showmodalcashback();
          await this.saveRecors(_this.registros);
          _this.notifyguardado({ guardo: true });
        }
      } catch (err) {
        this.youcansave = true;
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando los registros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema guardando los registros", err);
      }
    },
    transformdatatoprint(registros) {
      const _this = this;
      return new Promise(function (resolve, reject) {
        try {
          const dataprint = {};
          dataprint.empresa = _this.empresa;
          dataprint.comprobante = _this.comundata.comprobante;
          dataprint.registros = [];
          dataprint.contrapartida = {};
          dataprint.contrapartidas = [];
          dataprint.incluircambio =
            _this.encabezadoFactura.preferences.incluircambio;
          registros.forEach(function (k, v) {
            if (k.idcuenta.ingreso) {
              dataprint.registros.push(k);
            } else {
              if (dataprint.comprobante.cuenta === k.idcuenta._id) {
                dataprint.contrapartida = k;
              } else {
                if (dataprint.comprobante.factura.contrapartidas) {
                  dataprint.comprobante.factura.contrapartidas.forEach(
                    function (k2, v2) {
                      if (k2._id === k.idcuenta._id) {
                        k.nombrepers = k2.nombre;
                        dataprint.contrapartidas.push(k);
                      }
                    }
                  );
                }
              }
            }
          });
          dataprint.totales = dataprint.registros.reduce(getSum1, {
            subtotal: 0,
            iva: 0,
            total: 0,
          });
          var d = new Date(dataprint.registros[0].fecha);
          var d1 = parseInt(dataprint.registros[0].datosFactura.fpago);
          dataprint.vencimiento = sumarDias(d, d1);
          resolve(dataprint);
        } catch (err) {
          reject(err);
        }
      });
    },
    async saveandprint() {
      try {
        const _this = this;
        this.converttoregistros();
        const result = await this.saveRecors(_this.registros);
        this.dataprint = await this.transformdatatoprint(result.data);
        setTimeout(function () {
          _this.$print("printfra", {
            name: `${_this.dataprint.comprobante.nombre} - ${_this.dataprint.registros[0].documento} - ${_this.dataprint.registros[0].mes}`,
          });
          _this.notifyguardado({ guardo: true });
        }, 100);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando los registros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log(err);
      }
    },
    changeFilatotal(n) {
      this.filatotal = n;
    },
    async traeProductos(_this) {
      let result;
      try {
        result = await apiServices.get(`/productos`);
        _this.$store.commit("refreshProductos", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los productos.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los productos", err);
      }
    },
    notifyguardado(payload) {
      this.guardando = false;
      if (payload.guardo) {
        this.registros = [];
        this.productosfactura = [];
        this.totalesfactura = [];
        this.fila = -1;
        this.columna = 1;
        this.traeComprobantes();
        this.borrador = null;
        this.existborrador = false;
        this.textInputs.c1 = "";
        this.textInputs.c2 = null;
        this.textInputs.c3 = null;
        this.comundata.comprobante = null;
        this.comundata.numDoc = null;
        this.comundata.dia = null;
        this.comundata.periodo = null;
        this.comundata.cuentasdoc = null;
        document.getElementById("c1").focus();
        localStorage.removeItem("temporal");
        this.traeProductos(this);
      }
    },
    saveRecors(registros) {
      const _this = this;
      return new Promise(async function (resolve, reject) {
        try {
          let resto = 0;
          let indx = 0;
          // let contrapartida = 0;
          for (let index in registros) {
            const reg = registros[index];
            if (
              reg.idcuenta.toString() ===
              _this.comundata.comprobante.cuenta.toString()
            ) {
              indx = index;
            } else {
              resto +=
                parseInt(reg.tipo) === 1
                  ? Math.round(functions.dosDecimales(reg.valor) * 100)
                  : -Math.round(functions.dosDecimales(reg.valor) * 100);
            }
          }
          if (resto < 0) {
            resto = -resto;
          }
          if (indx !== 0) {
            registros[indx].valor = functions.dosDecimales(resto / 100);
          }
          const result = await apiServices.post(`/registroslote`, registros);
          _this.youcansave = true;
          return resolve(result);
        } catch (err) {
          _this.youcansave = true;
          return reject(err);
        }
      });
    },
    showmodalcashback() {
      this.showmodalcash = !this.showmodalcash;
    },
    async guardaRegistros() {
      const _this = this;
      let result;
      try {
        if (this.turno._id) {
          this.datamodalcashback = {
            name: this.contrapartida.nombre,
            valor: this.totalcontrapartida,
          };
          this.showmodalcashback();
        } else {
          result = await this.saveRecors(_this.registros);
          if (result.data) {
            this.youcansave = true;
            this.registros = [];
            this.productosfactura = [];
            this.notifyguardado({ guardo: true });
            this.$store.dispatch("notify", {
              message: "Registro guardado con éxito.",
              type: "is-primary",
              position: "top-center",
            });
          }
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando los registros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema guardando los registros", err);
      }
    },
    createreg(producto, estructura, orden) {
      const _this = this;
      const d = {
        // estos son los campos del batch
        batchcodigo: null,
        batchnombre: null,
        // aqui terminan los campos del batch
        idcuenta: null,
        idnit: null,
        descripcion: null,
        fecha: null,
        documento: null, // aqui va el numero de documento que tiene la comundata
        comprobanteid: null, // aqui va el id del comprobante que lo tiene la coumndata
        docRef: null,
        ccostos: null,
        base: 0,
        tipo: null, // 1 para el debito y 2 para el credito
        valor: 0,
        year: null, // aqui va el año que viene de comundata
        mes: null, // aqui va el mes que viene de commundata
        datosFactura: false, // este es para la factura
        turno: null, // este es para el id del turno en el caso que sea de un cuadre de caja
        tipor: null, // este es tipo de registro ingreso inventario costo o impuesto y solo aplica para punto de venta
        producto: null, // este es el id del producto para productos de punto de venta
        grupop: null, // este es el id del grupo del producto
        pventa: true, // este se pone true si es de punto de venta
        bodega: null, // este es el id de la bodega
        cantidad: 0, // numero de cantidades
        vlrUnitario: 0, // numero del valor unitario
        esTotal: false, // true o false para saber si es el total del documento
        descuento: null, // descuento este dato solo lo tiene las cuentas de ventas de la factura
        orden: null,
        // hasta aca es la estructura de la base de datos
        cuenta: null,
        cuentadetalle: null,
        nombreCuenta: null,
        nit: null,
        nombreNit: null,
        nombreCcostos: null,
        idCcostos: null,
        pptal: null,
        idpptal: null,
        nombrebodega: null,
        nbodega: null,
        nombreproducto: null,
        nproducto: null,
        productodetalle: null,
        porcentaje: null, // aqui va el porcentaje de retefuente
        tipo1: "+",
        tCuenta: true,
        tNit: false,
        tDescripcion: true,
        tCcosto: false,
        tBase: false,
        tDocref: false,
        tProducto: true,
        tCantidad: true,
        tDescuento: true,
        tPreciounitario: true,
        tBodega: false,
        tTipo: true,
        tValor: true,
        cumpleCuenta: true,
        cumpleNit: true,
        cumpleDescripcion: true,
        cumpleRef: true,
        cumpleCcosto: true,
        cumpleBase: true,
        cumpleProducto: true,
        cumpleCantidad: true,
        cumplePreciounitario: true,
        cumpleBodega: true,
        cumpleValor: true,
        cumpleTipo1: true,
        cumpleTodo: false,
      };
      if (this.empresa.modulos.cuadrecaja) {
        d.turno = this.turno._id;
      }
      if (estructura === "ingreso") {
        d.batchcodigo = producto.batchcodigo;
        d.batchnombre = producto.batchnombre;
        d.orden = orden;
        d.idcuenta = producto.objetoProducto.linea.ctaIngreso;
        d.idnit = _this.encabezadoFactura.idnit;
        if (this.empresa.modulos.descriptioninvoice) {
          d.descripcion = producto.descripcion;
        } else {
          d.descripcion = `Venta de ${producto.cantidad} ${producto.objetoProducto.unidad.codigo} de ${producto.nombreproducto} - documento ${_this.comundata.numDoc}`;
        }
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = "0";
        d.ccostos = _this.encabezadoFactura.nccostos;
        d.idCcostos = _this.encabezadoFactura.ccostos;
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 2 : 1;
        d.valor =
          _this.convertvalor(producto.cantidad) *
            _this.convertvalor(producto.vlrUnitario) -
          (_this.convertvalor(producto.cantidad) *
            _this.convertvalor(producto.vlrUnitario) *
            _this.convertvalor(producto.descuento)) /
            100;
        d.valor = functions.dosDecimales(d.valor);
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.tipor = "ingreso";
        d.producto = producto.objetoProducto._id;
        d.grupop = producto.objetoProducto.grupo._id;
        d.pventa = true;
        d.bodega = producto.bodega;
        d.cantidad = _this.convertvalor(producto.cantidad);
        d.vlrUnitario = _this.convertvalor(producto.vlrUnitario);
        d.esTotal = false;
        d.descuento = _this.convertvalor(producto.descuento);
        if (_this.encabezadoFactura.vendedor) {
          d.vendedor = _this.encabezadoFactura.vendedor;
        }
        const cuentaingreso = _this.cuentas.filter(
          (cuenta) => cuenta._id === producto.objetoProducto.linea.ctaIngreso
        );
        d.grupo = functions.grupo(cuentaingreso[0].codigo);
        d.sgrupo = functions.sgrupo(cuentaingreso[0].codigo);
        d.scuenta = functions.scuenta(cuentaingreso[0].codigo);
        d.datosFactura = {
          efectivo: 0,
          cambio: 0,
          impuesto: _this.convertvalor(producto.objetoProducto.linea.vImpuesto),
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura,
          orderReference: _this.itemsencabezado[6].input,
          cotizacion: _this.itemsencabezado[1].input,
        };
        d.cumpleTodo = true;
      }
      if (estructura === "impuesto") {
        d.idcuenta = producto.objetoProducto.linea.ctaImpto;
        d.idnit = _this.encabezadoFactura.idnit;
        d.descripcion = `Venta de ${producto.cantidad} ${producto.objetoProducto.unidad.codigo} de ${producto.nombreproducto} - documento ${_this.comundata.numDoc}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = "0";
        d.ccostos = _this.encabezadoFactura.nccostos;
        d.idCcostos = _this.encabezadoFactura.ccostos;
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 2 : 1;
        const valor =
          _this.convertvalor(producto.cantidad) *
            _this.convertvalor(producto.vlrUnitario) -
          (_this.convertvalor(producto.cantidad) *
            _this.convertvalor(producto.vlrUnitario) *
            _this.convertvalor(producto.descuento)) /
            100;
        d.base = functions.dosDecimales(valor);
        d.valor =
          (valor *
            _this.convertvalor(producto.objetoProducto.linea.vImpuesto)) /
          100;
        d.valor = functions.dosDecimales(d.valor);
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.tipor = "impuesto";
        d.pventa = true;
        d.esTotal = false;
        const cuentaimpuesto = _this.cuentas.filter(
          (cuenta) => cuenta._id === d.idcuenta
        );
        d.grupo = functions.grupo(cuentaimpuesto[0].codigo);
        d.sgrupo = functions.sgrupo(cuentaimpuesto[0].codigo);
        d.scuenta = functions.scuenta(cuentaimpuesto[0].codigo);
        d.datosFactura = {
          fpago: 0,
          texto: _this.textoFactura,
        };
        d.cumpleTodo = true;
      }
      if (estructura === "inventario") {
        d.batchcodigo = producto.batchcodigo;
        d.batchnombre = producto.batchnombre;
        d.idcuenta = producto.objetoProducto.linea.ctaInventario;
        d.idnit = _this.encabezadoFactura.idnit;
        d.descripcion = `Venta de ${producto.cantidad} ${producto.objetoProducto.unidad.codigo} de ${producto.nombreproducto} - documento ${_this.comundata.numDoc}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = "0";
        d.ccostos = "0";
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 2 : 1;
        if (
          producto.objetoProducto.datosProducto &&
          producto.objetoProducto.datosProducto[producto.bodega]
        ) {
          d.valor =
            producto.objetoProducto.datosProducto[producto.bodega].ultimoCalculo
              .costo * _this.convertvalor(producto.cantidad);
          d.vlrUnitario =
            producto.objetoProducto.datosProducto[
              producto.bodega
            ].ultimoCalculo.costo;
        } else {
          d.valor = 0;
          d.vlrUnitario = 0;
        }
        d.valor = functions.dosDecimales(d.valor);
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.tipor = "inventario";
        d.producto = producto.objetoProducto._id;
        d.grupop = producto.objetoProducto.grupo._id;
        d.pventa = true;
        d.bodega = producto.bodega;
        d.cantidad = _this.convertvalor(producto.cantidad);
        d.esTotal = false;
        const cuentainventario = _this.cuentas.filter(
          (cuenta) => cuenta._id === d.idcuenta
        );
        d.grupo = functions.grupo(cuentainventario[0].codigo);
        d.sgrupo = functions.sgrupo(cuentainventario[0].codigo);
        d.scuenta = functions.scuenta(cuentainventario[0].codigo);
        d.datosFactura = {
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura,
        };
        d.cumpleTodo = true;
      }
      if (estructura === "costo") {
        d.batchcodigo = producto.batchcodigo;
        d.batchnombre = producto.batchnombre;
        d.idcuenta = producto.objetoProducto.linea.ctaCosto;
        d.idnit = _this.encabezadoFactura.idnit;
        d.descripcion = `Venta de ${producto.cantidad} ${producto.objetoProducto.unidad.codigo} de ${producto.nombreproducto} - documento ${_this.comundata.numDoc}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = "0";
        d.ccostos = "0";
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 1 : 2;
        if (
          producto.objetoProducto.datosProducto &&
          producto.objetoProducto.datosProducto[producto.bodega]
        ) {
          d.valor =
            producto.objetoProducto.datosProducto[producto.bodega].ultimoCalculo
              .costo * _this.convertvalor(producto.cantidad);
          d.vlrUnitario =
            producto.objetoProducto.datosProducto[
              producto.bodega
            ].ultimoCalculo.costo;
        } else {
          d.valor = 0;
          d.vlrUnitario = 0;
        }
        d.valor = functions.dosDecimales(d.valor);
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.tipor = "costo";
        d.producto = producto.objetoProducto._id;
        d.grupop = producto.objetoProducto.grupo._id;
        d.pventa = true;
        d.bodega = producto.bodega;
        d.cantidad = _this.convertvalor(producto.cantidad);
        d.esTotal = false;
        const cuentacosto = _this.cuentas.filter(
          (cuenta) => cuenta._id === d.idcuenta
        );
        d.grupo = functions.grupo(cuentacosto[0].codigo);
        d.sgrupo = functions.sgrupo(cuentacosto[0].codigo);
        d.scuenta = functions.scuenta(cuentacosto[0].codigo);
        d.datosFactura = {
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura,
        };
        d.cumpleTodo = true;
      }
      if (estructura === "contrapartida") {
        d.idcuenta = producto._id;
        d.idnit = producto.tercero
          ? _this.encabezadoFactura.idnit
          : _this.empresa.nit0;
        d.descripcion = `Factura ${_this.comundata.numDoc} - ${_this.encabezadoFactura.nombreNit}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = producto.dctoref ? _this.comundata.numDoc : "0";
        d.ccostos = producto.ccosto ? _this.encabezadoFactura.nccostos : "0";
        d.idCcostos = producto.ccosto ? _this.encabezadoFactura.ccostos : null;
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 1 : 2;
        d.valor = _this.totalcontrapartida;
        d.valor = functions.dosDecimales(d.valor);
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.esTotal = false;
        d.grupo = functions.grupo(producto.codigo);
        d.sgrupo = functions.sgrupo(producto.codigo);
        d.scuenta = functions.scuenta(producto.codigo);
        d.datosFactura = {
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura,
        };
        d.cumpleTodo = true;
      }
      if (estructura === "total") {
        d.idcuenta = producto._id;
        d.idnit = producto.tercero
          ? _this.encabezadoFactura.idnit
          : _this.empresa.nit0;
        d.descripcion = `Factura ${_this.comundata.numDoc} - ${_this.encabezadoFactura.nombreNit}`;
        d.fecha = new Date(
          functions.year(_this.comundata.periodo),
          functions.mes(_this.comundata.periodo) - 1,
          _this.comundata.dia
        );
        d.documento = _this.comundata.numDoc;
        d.comprobanteid = _this.comundata.comprobante._id;
        d.docRef = producto.dctoref ? _this.comundata.numDoc : "0";
        d.ccostos = producto.ccosto ? _this.encabezadoFactura.nccostos : "0";
        d.idCcostos = producto.ccosto ? _this.encabezadoFactura.ccostos : null;
        d.tipo = _this.comundata.comprobante.tipo === 1 ? 1 : 2;
        d.valor = _this.convertvalor(producto.valor);
        d.valor = functions.dosDecimales(d.valor);
        d.year = functions.year(_this.comundata.periodo);
        d.mes = functions.mes(_this.comundata.periodo);
        d.esTotal = false;
        d.grupo = functions.grupo(producto.codigo);
        d.sgrupo = functions.sgrupo(producto.codigo);
        d.scuenta = functions.scuenta(producto.codigo);
        d.datosFactura = {
          fpago: _this.convertvalor(_this.encabezadoFactura.fpago),
          texto: _this.textoFactura,
        };
        d.cumpleTodo = true;
      }
      if (this.isNCElect) {
        // si el documento es de nota credito electronica
        d.datosFactura.nc = {
          cufe: _this.dataNC.fraelect.cufe,
          prefijo: _this.dataNC.fraelect.prefijo,
          documento: _this.dataNC.fraelect.documento,
          responsecode: _this.ncdata.responsecode,
          fecha: _this.dataNC.fecha,
          description: "",
        };
        const descriptions = {
          1: "Devolución de parte de los bienes; no aceptación de partes del servicio",
          2: "Anulación de factura electrónica",
          3: "Rebaja total aplicada",
          4: "Descuento total aplicado",
          5: "Rescisión: nulidad por falta de requisitos",
          6: "Otros",
        };
        d.datosFactura.nc.description =
          descriptions[d.datosFactura.nc.responsecode];
      }
      if (d.valor > 0) {
        _this.registros.push(d);
      }
    },
    createregistros(producto, orden) {
      const _this = this;
      _this.createreg(producto, "ingreso", orden);
      if (producto.objetoProducto.linea.impuesto) {
        _this.createreg(producto, "impuesto");
      }
      if (producto.objetoProducto.linea.inventario) {
        _this.createreg(producto, "inventario");
        _this.createreg(producto, "costo");
      }
    },
    validaRenglon(fila) {
      const _this = this;
      if (
        _this.productosfactura[fila].cumpleProducto &&
        _this.productosfactura[fila].cumpleCantidad &&
        _this.productosfactura[fila].cumplePreciounitario &&
        _this.productosfactura[fila].cumpleBodega &&
        _this.productosfactura[fila].cumpleBatchcodigo &&
        _this.productosfactura[fila].cumpleDescuento
      ) {
        _this.productosfactura[fila].cumpleTodo = true;
      } else {
        _this.productosfactura[fila].cumpleTodo = false;
      }
    },
    validatodo() {
      let cumple = true;
      const _this = this;
      for (let index in this.productosfactura) {
        cumple = _this.productosfactura[index].cumpleTodo;
      }
      return cumple;
    },
    converttoregistros() {
      this.registros = [];
      const _this = this;
      for (let i = 0; i < this.productosfactura.length; i++) {
        this.validaRenglon(i);
        if (
          _this.productosfactura[i].cumpleTodo &&
          _this.convertvalor(_this.productosfactura[i].cantidad) > 0 &&
          _this.convertvalor(_this.productosfactura[i].vlrUnitario) > 0
        ) {
          _this.createregistros(_this.productosfactura[i], i);
        }
      }
      _this.createreg(_this.contrapartida, "contrapartida");
      if (_this.totalesfactura.length > 0) {
        for (let i = 0; i < _this.totalesfactura.length; i++) {
          _this.createreg(_this.totalesfactura[i], "total");
        }
      }
    },
    f10guardar() {
      if (this.youcansave) {
        this.youcansave = false;
        if (this.isNCElect) {
          // si es un documento de nota credito electronica se debe validar que si selecciono una factura valida
          if (!this.dataNC.fraelect.cufe) {
            this.youcansave = true;
            this.$store.dispatch("notify", {
              message: "Debe seleccionar un documento referencia.",
              type: "is-warning",
              position: "top-center",
            });
            return false;
          }
        }
        this.validaencabezado(1);
        this.validaencabezado(2);
        this.validaencabezado(3);
        this.validaencabezado(4);
        this.validaencabezado(5);
        this.validaencabezado(6);
        this.validaencabezado(7);
        if (
          this.encabezadoFactura.cumpleCcosto &&
          this.encabezadoFactura.cumpleNit &&
          this.encabezadoFactura.cumpleBodega &&
          this.encabezadoFactura.cumpleLprecios
        ) {
          this.encabezadoFactura.cumpletodo = true;
        } else {
          this.youcansave = true;
          this.$store.dispatch("notify", {
            message: "Verifique los campos del encabezado de la factura.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        this.converttoregistros();
        const valida = this.validatodo();
        if (!valida) {
          this.$store.dispatch("notify", {
            message:
              "Verifique los datos en rojo antes de guardar los registros.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        this.guardaRegistros();
      }
    },
    showInputtotal(f) {
      if (this.fila === -2) {
        if (this.filatotal === f) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    activetotal(f) {
      if (this.fila === -2 && f === this.filatotal) {
        return {
          selected: true,
        };
      }
    },
    selDatatotal(filatotal) {
      this.fila = -2;
      this.filatotal = filatotal;
    },
    changeDatatotal(payload) {
      this.totalesfactura[payload.filatotal].valor = this.convertvalor(
        payload.data
      );
    },
    deleteReg(payload) {
      this.productosfactura.splice(payload, 1);
      this.fila = payload - 1;
    },
    addReg() {
      this.createregproducto(this);
    },
    validaproducto(col) {
      const _this = this;
      let data = null;
      data = functions.findData(
        _this.productos,
        _this.productosfactura[this.fila].items[0].input,
        "codigo"
      );
      if (data) {
        const keysitems = [];
        for (let index in this.productosfactura[this.fila].items) {
          keysitems.push(_this.productosfactura[this.fila].items[index].cod);
        }
        const nbodega = keysitems.indexOf("nbodega");
        const nvlrunitario = keysitems.indexOf("vlrUnitario");
        _this.productosfactura[_this.fila].objetoProducto = data;
        _this.productosfactura[_this.fila].nombreproducto = data.descripcion;
        _this.productosfactura[_this.fila].producto = data._id;
        let lprecio = parseInt(this.encabezadoFactura.lprecios);
        if (isNaN(lprecio)) {
          lprecio = 0;
        }
        if (parseFloat(_this.productosfactura[_this.fila].vlrUnitario) === 0) {
          _this.productosfactura[_this.fila].vlrUnitario = parseFloat(
            data.precios[lprecio]
          );
          _this.productosfactura[this.fila].items[nvlrunitario].input =
            parseFloat(data.precios[lprecio]);
          _this.productosfactura[_this.fila].cumpleProducto = true;
          _this.productosfactura[this.fila].items[nvlrunitario].css.status =
            "normal";
        }
        if (!_this.productosfactura[_this.fila].bodega) {
          _this.productosfactura[_this.fila].bodega = _this.comundata
            .comprobante.factura.bodega
            ? _this.comundata.comprobante.factura.bodega._id
            : null;
          _this.productosfactura[this.fila].items[nbodega].css.status =
            "normal";
          _this.productosfactura[this.fila].items[nbodega].inputid = _this
            .comundata.comprobante.factura.bodega
            ? _this.comundata.comprobante.factura.bodega._id
            : null;
          _this.productosfactura[this.fila].items[nbodega].input = _this
            .comundata.comprobante.factura.bodega
            ? _this.comundata.comprobante.factura.bodega.codigo
            : null;
          _this.productosfactura[this.fila].items[nbodega].inputrich = _this
            .comundata.comprobante.factura.bodega
            ? _this.comundata.comprobante.factura.bodega.descripcion
            : null;
          _this.productosfactura[_this.fila].nbodega = _this.comundata
            .comprobante.factura.bodega
            ? _this.comundata.comprobante.factura.bodega.codigo
            : null;
          _this.productosfactura[_this.fila].nombrebodega = _this.comundata
            .comprobante.factura.bodega
            ? _this.comundata.comprobante.factura.bodega.descripcion
            : null;
        }
        _this.productosfactura[this.fila].items[col - 1].css.status = "normal";
        _this.productosfactura[this.fila].items[col - 1].inputrich =
          data.descripcion;
        _this.productosfactura[this.fila].items[col - 1].inputid = data._id;
      } else {
        _this.productosfactura[_this.fila].cumpleProducto = false;
        _this.productosfactura[this.fila].items[col - 1].css.status = "danger";
        _this.productosfactura[this.fila].items[col - 1].inputrich = null;
        _this.productosfactura[this.fila].items[col - 1].inputid = null;
      }
    },
    validadescripcion(col) {
      const _this = this;
      if (_this.productosfactura[this.fila].items[col - 1].input) {
        _this.productosfactura[_this.fila].descripcion =
          _this.productosfactura[this.fila].items[col - 1].input;
        _this.productosfactura[this.fila].items[col - 1].css.status = "normal";
        _this.productosfactura[_this.fila].cumpleDescripcion = true;
      } else {
        _this.productosfactura[_this.fila].cumpleDescripcion = false;
        _this.productosfactura[this.fila].items[col - 1].css.status = "danger";
      }
    },
    validaBodega(col) {
      const _this = this;
      let data = null;
      data = functions.findData(
        _this.bodegas,
        _this.productosfactura[this.fila].items[col - 1].input,
        "codigo"
      );
      if (data) {
        _this.productosfactura[_this.fila].bodega = data._id;
        _this.productosfactura[_this.fila].nombrebodega = data.descripcion;
        _this.productosfactura[_this.fila].cumpleBodega = true;
        _this.productosfactura[this.fila].items[col - 1].css.status = "normal";
        _this.productosfactura[this.fila].items[col - 1].inputid = data._id;
        _this.productosfactura[this.fila].items[col - 1].inputrich =
          data.descripcion;
      } else {
        _this.productosfactura[this.fila].items[col - 1].css.status = "danger";
        _this.productosfactura[this.fila].items[col - 1].inputrich = null;
        _this.productosfactura[_this.fila].cumpleBodega = false;
      }
    },
    validaencabezado(col) {
      const _this = this;
      let data = null;
      if (col === 1) {
        // debe validar el cliente
        data = functions.findData(
          _this.nits,
          _this.itemsencabezado[0].input,
          "codigo"
        );
      }
      if (col === 2) {
        // valida la cotizacion
        data = {
          nombre: null,
          _id: null,
        };
      }
      if (col === 3) {
        // valida el vendedor
        data = functions.findData(
          _this.vendedores,
          _this.itemsencabezado[2].input,
          "codigo"
        );
        if (!data) {
          data = {
            nombre: null,
            _id: null,
          };
        }
      }
      if (col === 4) {
        // valida vencimientos
        data = functions.findData(
          _this.encabezadoFactura.vencimientos,
          parseInt(_this.itemsencabezado[3].input),
          "codigo"
        );
        if (data) {
          data._id = data.codigo;
        }
      }
      if (col === 5) {
        // valida listas de precios
        data = functions.findData(
          _this.listas,
          String(_this.itemsencabezado[4].input),
          "codigo"
        );
        if (data) {
          data._id = data.codigo;
        }
      }
      if (col === 6) {
        // valida Centro de costos
        data = functions.findData(
          _this.comundata.ccostos,
          _this.itemsencabezado[5].input,
          "codigo"
        );
      }
      if (col === 7) {
        // valida order reference
        data = {
          nombre: null,
          _id: null,
        };
      }
      if (data) {
        _this.encabezadoFactura[_this.itemsencabezado[col - 1].texto] =
          data.nombre;
        _this.encabezadoFactura[_this.itemsencabezado[col - 1].cod] =
          data.codigo;
        _this.encabezadoFactura[_this.itemsencabezado[col - 1].bd] = data._id;
        _this.encabezadoFactura[_this.itemsencabezado[col - 1].valida] = true;
        _this.itemsencabezado[col - 1].css.status = "normal";
        _this.itemsencabezado[col - 1].inputrich = data.nombre;
        _this.itemsencabezado[col - 1].inputid = data._id;
      } else {
        _this.encabezadoFactura[_this.itemsencabezado[col - 1].cod] = null;
        _this.encabezadoFactura[_this.itemsencabezado[col - 1].texto] = null;
        _this.encabezadoFactura[_this.itemsencabezado[col - 1].bd] = null;
        _this.encabezadoFactura[_this.itemsencabezado[col - 1].valida] = false;
        _this.itemsencabezado[col - 1].css.status = "danger";
        _this.itemsencabezado[col - 1].inputrich = null;
        _this.itemsencabezado[col - 1].inputid = null;
      }
    },
    validacantidad() {
      const _this = this;
      const keysitems = [];
      for (let index in this.productosfactura[this.fila].items) {
        keysitems.push(_this.productosfactura[this.fila].items[index].cod);
      }
      const ncantidad = keysitems.indexOf("cantidad");
      const cantidad = functions.dosDecimales(
        _this.productosfactura[_this.fila].items[ncantidad].input
      );
      if (cantidad === 0) {
        _this.productosfactura[_this.fila].cumpleCantidad = false;
        _this.productosfactura[this.fila].items[ncantidad].css.status =
          "danger";
        _this.productosfactura[this.fila].items[ncantidad].inputrich = null;
        _this.productosfactura[this.fila].items[ncantidad].inputid = null;
      } else {
        _this.productosfactura[_this.fila].cantidad = cantidad;
        _this.productosfactura[_this.fila].cumpleCantidad = true;
        _this.productosfactura[this.fila].items[ncantidad].css.status =
          "normal";
      }
    },
    validapreciounitario() {
      const _this = this;
      const keysitems = [];
      for (let index in this.productosfactura[this.fila].items) {
        keysitems.push(_this.productosfactura[this.fila].items[index].cod);
      }
      const npreciounitario = keysitems.indexOf("vlrUnitario");
      const punitario = functions.dosDecimales(
        _this.productosfactura[_this.fila].items[npreciounitario].input
      );
      if (punitario === 0) {
        _this.productosfactura[_this.fila].cumplePreciounitario = false;
        _this.productosfactura[this.fila].items[npreciounitario].css.status =
          "danger";
        _this.productosfactura[this.fila].items[npreciounitario].inputrich =
          null;
        _this.productosfactura[this.fila].items[npreciounitario].inputid = null;
      } else {
        _this.productosfactura[_this.fila].vlrUnitario = punitario;
        _this.productosfactura[_this.fila].cumplePreciounitario = true;
        _this.productosfactura[this.fila].items[npreciounitario].css.status =
          "normal";
      }
    },
    validadescuento() {
      const _this = this;
      const keysitems = [];
      for (let index in this.productosfactura[this.fila].items) {
        keysitems.push(_this.productosfactura[this.fila].items[index].cod);
      }
      const ndescuento = keysitems.indexOf("descuento");
      const descuento = functions.dosDecimales(
        _this.productosfactura[_this.fila].items[ndescuento].input
      );
      if (descuento === 0) {
        _this.productosfactura[_this.fila].cumpleDescuento = true;
      } else {
        _this.productosfactura[_this.fila].descuento = descuento;
        _this.productosfactura[_this.fila].cumpleDescuento = true;
      }
    },
    validalote() {
      const _this = this;
      const keysitems = [];
      for (let index in this.productosfactura[this.fila].items) {
        keysitems.push(_this.productosfactura[this.fila].items[index].cod);
      }
      const nbatch = keysitems.indexOf("batchcodigo");
      _this.productosfactura[_this.fila].batchcodigo =
        _this.productosfactura[_this.fila].items[nbatch].input;
      _this.productosfactura[_this.fila].batchnombre =
        _this.productosfactura[_this.fila].items[nbatch].inputrich;
    },
    validaregistros(col) {
      const codigo = this.productosfactura[this.fila].items[col - 1]
        ? this.productosfactura[this.fila].items[col - 1].cod
        : "sincodigo";
      if (codigo === "nproducto") {
        this.validaproducto(col);
      }
      if (codigo === "descripcion") {
        this.validadescripcion(col);
      }
      if (codigo === "nbodega") {
        this.validaBodega(col);
      }
      if (codigo === "batchcodigo") {
        this.validalote();
      }
      if (codigo === "cantidad") {
        this.validacantidad();
      }
      if (codigo === "vlrUnitario") {
        this.validapreciounitario();
      }
      if (codigo === "descuento") {
        this.validadescuento();
      }
    },
    async traeCCostos(_this) {
      let result;
      try {
        result = await apiServices.get(`/ccostos`);
        _this.comundata.ccostos = result.data;
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los centros de costos.",
          type: "is-danger",
          position: "top-center",
        });
      }
    },
    ingresaDataEnItemsEncabezado() {
      this.itemsencabezado[0].input = this.encabezadoFactura.nit;
      this.itemsencabezado[0].inputrich = this.encabezadoFactura.nombreNit;
      this.itemsencabezado[0].inputid = this.encabezadoFactura.idnit;
      this.itemsencabezado[1].input = "Sin cotización";
      this.itemsencabezado[2].input = "Sin Vendedor";
      if (this.encabezadoFactura.fpago.toString() === "0") {
        this.itemsencabezado[3].input = 0;
        this.itemsencabezado[3].inputrich = "Contado";
      } else {
        this.itemsencabezado[3].input = this.encabezadoFactura.fpago;
        this.itemsencabezado[3].inputrich = "días";
      }
      this.itemsencabezado[4].input = this.encabezadoFactura.lprecios;
      this.itemsencabezado[4].inputrich = this.encabezadoFactura.nombrelprecios;
      this.itemsencabezado[5].input = this.encabezadoFactura.nccostos;
      this.itemsencabezado[5].inputrich = this.encabezadoFactura.nombreCcostos;
      this.itemsencabezado[5].inputid = this.encabezadoFactura.ccostos;
      this.itemsencabezado[6].input = 0;
      this.cambio++;
    },
    changeinput(data) {
      this[data.variable][data.columna - 1].input = data.data;
    },
    changeinputreg(data) {
      this.productosfactura[data.variable].items[data.columna - 1].input =
        data.data;
      const codColumna =
        this.productosfactura[data.fila].items[data.columna - 1].cod;
      if (codColumna === "cantidad") {
        this.productosfactura[data.fila].cantidad = data.data;
      }
      if (codColumna === "vlrUnitario") {
        this.productosfactura[data.fila].vlrUnitario = data.data;
      }
      if (codColumna === "descuento") {
        this.productosfactura[data.fila].descuento = data.data;
      }
    },
    async f3(item) {
      const _this = this;
      if (item.cod === "nit") {
        const datanits = this.nits.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.nombre,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione el Tercero",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: datanits,
          result: "nits",
        });
      }
      if (item.cod === "nvendedor") {
        const datavendedor = this.vendedores.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.nombre,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione el Vendedor",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: datavendedor,
          result: "vendedor",
        });
      }
      if (item.cod === "lprecios") {
        const keyslistadeprecios = Object.keys(
          this.empresa.modulos.pventa.listas
        );
        const datalistas = keyslistadeprecios.map((e) => {
          const d = {
            codigo: parseInt(e),
            nombre: _this.empresa.modulos.pventa.listas[e],
            id: e,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione la Lista",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: datalistas,
          result: "lprecios",
        });
      }
      if (item.cod === "fpago") {
        const datafpago = this.encabezadoFactura.vencimientos.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.nombre,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione la forma de pago",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: datafpago,
          result: "fpago",
        });
      }
      if (item.cod === "nccostos") {
        const dataccostos = this.comundata.ccostos.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.nombre,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione el Centro de Costos",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: dataccostos,
          result: "ccostos",
        });
      }
      if (item.cod === "nproducto") {
        const dataproductos = this.productos.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.descripcion,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione el Producto",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: dataproductos,
          result: "producto",
        });
      }
      if (item.cod === "nbodega") {
        const databodega = this.bodegas.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.descripcion,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione la Bodega",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: databodega,
          result: "bodega",
        });
      }
      if (item.cod === "batchcodigo") {
        const _this = this;
        if (
          _this.productosfactura[_this.fila].objetoProducto._id &&
          _this.productosfactura[_this.fila].bodega
        ) {
          const result = await apiServices.get(
            `/calculaproductoind/${
              _this.productosfactura[_this.fila].objetoProducto._id
            }/${_this.productosfactura[_this.fila].bodega}`
          );
          if (result.data) {
            const lotes = { list: [] };
            for (let index in result.data) {
              const dat = result.data[index];
              if (
                lotes.list.indexOf(
                  dat._id.batchcodigo ? dat._id.batchcodigo : "*"
                ) === -1
              ) {
                lotes.list.push(
                  dat._id.batchcodigo ? dat._id.batchcodigo : "*"
                );
                lotes[dat._id.batchcodigo ? dat._id.batchcodigo : "*"] = {
                  name: dat._id.batchnombre ? dat._id.batchnombre : "-",
                  existencia: 0,
                };
              }
              lotes[
                dat._id.batchcodigo ? dat._id.batchcodigo : "*"
              ].existencia += dat.valor;
            }
            const datalote = [];
            for (let index in lotes.list) {
              const codLote = lotes.list[index];
              if (lotes[codLote].existencia !== 0) {
                const d = {
                  codigo: codLote,
                  id: codLote,
                  nombre: `${lotes[codLote].name} - Existencia ${lotes[codLote].existencia}`,
                  selected: false,
                };
                datalote.push(d);
              }
            }
            this.$store.commit("launchModal", {
              title: "Seleccione el Lote",
              oktext: "Aceptar",
              canceltext: "Cancelar",
              titleTable: [
                { cod: "codigo", name: "Código" },
                { cod: "nombre", name: "Nombre" },
              ],
              table: datalote,
              result: "batch",
            });
          }
        }
      }
      if (item.cod === "cotizacion") {
        const tercero = this.encabezadoFactura.idnit;
        if (tercero) {
          try {
            const result = await apiServices.get(
              `/findcotizaciones/${tercero}`
            );
            if (result.data) {
              const mes = {
                1: "ENE",
                2: "FEB",
                3: "MZO",
                4: "ABR",
                5: "MYO",
                6: "JUN",
                7: "JUL",
                8: "AGO",
                9: "SEP",
                10: "OCT",
                11: "NOV",
                12: "DIC",
              };
              const datanits = result.data.map((e) => {
                const d = {
                  codigo: `${e._id.documento}-${e._id.year}-${e._id.mes}`,
                  nombre: `DOCUMENTO ${e._id.documento} - ${
                    mes[e._id.mes]
                  } de ${e._id.year}`,
                  id: `${e._id.documento}-${e._id.year}-${e._id.mes}-${e._id.comprobanteid}`,
                  comprobante: e._id.comprobanteid,
                  documento: e._id.documento,
                  year: e._id.year,
                  mes: e._id.mes,
                  selected: false,
                };
                return d;
              });
              this.$store.commit("launchModal", {
                title: "Seleccione el Documento",
                oktext: "Aceptar",
                canceltext: "Cancelar",
                titleTable: [
                  { cod: "codigo", name: "Código" },
                  { cod: "nombre", name: "Nombre" },
                ],
                table: datanits,
                result: "cotizacion",
              });
            } else {
              this.$store.dispatch("notify", {
                message: "No hay documentos",
                type: "is-warning",
                position: "top-center",
              });
            }
          } catch (err) {
            this.$store.dispatch("notify", {
              message: "Ocurrio un error consultando el documento",
              type: "is-warning",
              position: "top-center",
            });
          }
        } else {
          this.$store.dispatch("notify", {
            message: "Antes debe seleccionar un tercero válido",
            type: "is-warning",
            position: "top-center",
          });
        }
      }
    },
    keyitem(e) {
      if (e) {
        if (e.keyCode === 121) {
          this.f10guardar();
        }
      }
    },
    classfila(fila) {
      if (this.fila === fila) {
        return "selected";
      }
    },
    changeFila(n) {
      this.fila = n;
    },
    changeColumna(n) {
      this.columna = n;
    },
    async traeCuentas(_this) {
      let result;
      try {
        result = await apiServices.get(`/cuentas/reg`);
        _this.$store.commit("refreshCuentas", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando las cuentas.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando las cuentas", err);
      }
    },
    async traeusermongo() {
      try {
        const result = await apiServices.get(`/myuser`);
        this.usermongo = result.data;
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando el usuario.",
          type: "is-danger",
          position: "top-center",
        });
      }
    },
    createregproducto(_this, isSplice) {
      const d = {
        // estos son los campos del batch
        batchcodigo: null,
        batchnombre: null,
        // aqui terminan los campos del batch
        producto: null, // este es el id del producto para productos de punto de venta
        grupop: null, // este es el id del grupo del producto
        cantidad: 1, // numero de cantidades
        vlrUnitario: 0, // numero del valor unitario
        esTotal: false, // true o false para saber si es el total del documento
        descuento: 0, // descuento este dato solo lo tiene las cuentas de ventas de la factura
        orden: null,
        objetoProducto: null,
        bodega: null,
        // hasta aca es la estructura de la base de datos
        nbodega: null,
        nombrebodega: null,
        nombreproducto: null,
        nproducto: null,
        productodetalle: null,
        tProducto: true,
        tCantidad: true,
        tDescuento: true,
        tBodega: true,
        tBatchcodigo: false,
        tBatchnombre: false,
        tPreciounitario: true,
        cumpleBodega: true,
        cumpleProducto: true,
        cumpleCantidad: true,
        cumplePreciounitario: true,
        cumpleDescripcion: true,
        cumpleDescuento: true,
        cumpleBatchcodigo: true,
        cumpleTodo: false,
        items: [
          {
            cod: "nproducto",
            nombre: "Producto",
            bd: "producto",
            tiene: "tProducto",
            valida: "cumpleProducto",
            texto: "nombreproducto",
            css: { status: "normal", size: "normal" }, // sirve para poner de color el boton warning o danger o light tambien si es small o large
            input: "xx",
            inputrich: "Nombre del producto",
            inputid: null,
          },
          {
            cod: "descripcion",
            nombre: "Descripción",
            bd: "descripcion",
            tiene: "tDescripcion",
            valida: "cumpleDescripcion",
            texto: "descripcion",
            css: { status: "normal", size: "normal" }, // sirve para poner de color el boton warning o danger o light tambien si es small o large
            input: "Detalle de la transacción",
            inputrich: null,
            inputid: null,
          },
          {
            cod: "nbodega",
            nombre: "Bodega",
            bd: "bodega",
            tiene: "tBodega",
            valida: "cumpleBodega",
            texto: "nombrebodega",
            css: { status: "normal", size: "normal" },
            input: "No encontrada",
            inputrich: null,
            inputid: null,
          },
          {
            cod: "batchcodigo",
            nombre: "Cod Lote",
            bd: "batchcodigo",
            tiene: "tBatchcodigo",
            valida: "cumpleBatchcodigo",
            texto: "batchcodigo",
            css: { status: "normal", size: "normal" },
            input: "---",
            inputrich: null,
            inputid: null,
          },
          {
            cod: "cantidad",
            nombre: "Cantidad",
            bd: "cantidad",
            tiene: "tCantidad",
            valida: "cumpleCantidad",
            texto: "cantidad",
            css: { status: "normal", size: "normal" },
            input: 1,
            inputrich: null,
            inputid: null,
          },
          {
            cod: "vlrUnitario",
            nombre: "Vlr Unitario",
            bd: "vlrUnitario",
            tiene: "tPreciounitario",
            valida: "cumplePreciounitario",
            texto: "vlrUnitario",
            css: { status: "normal", size: "normal" },
            input: 0,
            inputrich: null,
            inputid: null,
          },
          {
            cod: "descuento",
            nombre: "Descuento",
            bd: "descuento",
            tiene: "tDescuento",
            valida: "cumpleDescuento",
            texto: "descuento",
            css: { status: "normal", size: "normal" },
            input: 0,
            inputrich: null,
            inputid: null,
          },
        ],
      };
      if (!this.empresa.modulos.descriptioninvoice) {
        const codsItems = [];
        for (let index in d.items) {
          codsItems.push(d.items[index].cod);
        }
        const n = codsItems.indexOf("descripcion");
        d.items.splice(n, 1);
      }
      if (!this.empresa.lote) {
        const codsItems1 = [];
        for (let index in d.items) {
          codsItems1.push(d.items[index].cod);
        }
        const n1 = codsItems1.indexOf("batchcodigo");
        d.items.splice(n1, 1);
      }
      if (isSplice) {
        _this.productosfactura.splice(_this.productosfactura.length - 1, 0, d);
      } else {
        _this.productosfactura.push(d);
      }
    },
    dataDefault() {
      const _this = this;
      // carga los datos por default de la factura
      this.encabezadoFactura.idnit = this.comundata.comprobante.factura.nit
        ? this.comundata.comprobante.factura.nit._id
        : "";
      this.encabezadoFactura.nit = this.comundata.comprobante.factura.nit
        ? this.comundata.comprobante.factura.nit.codigo
        : "";
      this.encabezadoFactura.nombreNit = this.comundata.comprobante.factura.nit
        ? this.comundata.comprobante.factura.nit.nombre
        : "";
      this.encabezadoFactura.bodega = this.comundata.comprobante.factura.bodega
        ? this.comundata.comprobante.factura.bodega._id
        : "";
      this.encabezadoFactura.nbodega = this.comundata.comprobante.factura.bodega
        ? this.comundata.comprobante.factura.bodega.codigo
        : "";
      this.encabezadoFactura.nombrebodega = this.comundata.comprobante.factura
        .bodega
        ? this.comundata.comprobante.factura.bodega.descripcion
        : "";
      this.encabezadoFactura.lprecios = this.comundata.comprobante.factura
        .lprecios
        ? this.comundata.comprobante.factura.lprecios.codigo
        : "";
      this.encabezadoFactura.nombrelprecios = this.comundata.comprobante.factura
        .lprecios
        ? this.comundata.comprobante.factura.lprecios.nombre
        : "";
      this.encabezadoFactura.nombreCcostos = this.comundata.comprobante.factura
        .ccostos
        ? this.comundata.comprobante.factura.ccostos.nombre
        : "";
      this.encabezadoFactura.nccostos = this.comundata.comprobante.factura
        .ccostos
        ? this.comundata.comprobante.factura.ccostos.codigo
        : "";
      this.encabezadoFactura.ccostos = this.comundata.comprobante.factura
        .ccostos
        ? this.comundata.comprobante.factura.ccostos._id
        : "";
      this.encabezadoFactura.fpago = this.comundata.comprobante.vencimiento;
      const nombrefpago = this.encabezadoFactura.vencimientos.filter(
        (vencimiento) =>
          vencimiento.codigo === parseInt(_this.encabezadoFactura.fpago)
      );
      this.encabezadoFactura.nombrefpago = nombrefpago[0].nombre;
      const contrapartida = this.cuentas.filter(
        (cuenta) => cuenta._id === _this.comundata.comprobante.cuenta
      );
      this.contrapartida = contrapartida[0];
      if (this.comundata.comprobante.factura.contrapartidas) {
        _this.totalesfactura = [];
        this.comundata.comprobante.factura.contrapartidas.forEach(
          (contrapartida) => {
            const data = {
              _id: contrapartida._id,
              codigo: contrapartida.codigo,
              nombre: contrapartida.nombre,
              dctoref: contrapartida.dctoref,
              base: contrapartida.base,
              ccosto: contrapartida.ccosto,
              tercero: contrapartida.tercero,
              valor: 0,
            };
            _this.totalesfactura.push(data);
          }
        );
      }

      // this.encabezadoFactura.nlprecios = this.comundata.comprobante.factura.bodega.descripcion;
    },
    tomadatacomprobante() {
      if (
        this.usermongo.companys[this.empresa._id] &&
        this.usermongo.companys[this.empresa._id].preferences &&
        this.usermongo.companys[this.empresa._id].preferences.cuenta &&
        this.usermongo.companys[this.empresa._id].preferences.impresora &&
        this.usermongo.companys[this.empresa._id].preferences.incluircambio
      ) {
        this.encabezadoFactura.preferences.cuenta =
          this.usermongo.companys[this.empresa._id].preferences.cuenta;
        this.encabezadoFactura.preferences.impresora =
          this.usermongo.companys[this.empresa._id].preferences.impresora;
        this.encabezadoFactura.preferences.incluircambio =
          this.usermongo.companys[this.empresa._id].preferences.incluircambio;
      } else {
        this.errorpreferences = true;
      }
      if (this.borrador) {
        this.registros = this.borrador.registros;
        this.encabezadoFactura = this.borrador.encabezado;
        this.contrapartida = this.borrador.contrapartida;
        this.productosfactura = this.borrador.productosfactura;
        this.totalesfactura = this.borrador.totalesfactura;
      } else {
        this.dataDefault();
        this.createregproducto(this, false);
      }
    },
    keyfunction(e, id) {
      if (e.keyCode === 113) {
        if (this.editsel) {
          this.editsel = false;
        } else {
          this.editsel = true;
        }
      }
      if (id === "c1") {
        if (e.keyCode === 13) {
          e.preventDefault();
          document.getElementById("c3").focus();
        }
        if (e.keyCode === 39) {
          if (!this.editsel) {
            e.preventDefault();
            document.getElementById("c3").focus();
          }
        }
        if (e.keyCode === 114) {
          e.preventDefault();
          this.launchModal();
        }
      }
      if (id === "c3") {
        if (e.keyCode === 37) {
          e.preventDefault();
          document.getElementById("c1").focus();
        }
        if (e.keyCode === 13) {
          e.preventDefault();
          if (this.comundata.comprobante) {
            document.getElementById("inputItems").focus();
          } else {
            document.getElementById("c1").focus();
          }
        }
      }
    },
    focusfunction(el) {
      if (el === "c1") {
        this.editday = true;
      }
    },
    async traeComprobantes() {
      const _this = this;
      let result;
      try {
        result = await apiServices.get(`/comprobantes`);
        this.comprobanteModal = [];
        this.comprobanteNC = [];
        this.comprobantes = result.data;
        result.data.forEach((el) => {
          const d = {};
          d.codigo = el.codigo;
          d.nombre = el.nombre;
          d.id = el._id;
          d.selected = false;
          if (el.estructura === "factura") {
            // que aparezcan solo los tipo factura.
            _this.comprobanteModal.push(d);
          }
          if (el.isElectronico && el.tipodocumento !== "NC") {
            // que aparezcan solo los tipo factura.
            _this.comprobanteNC.push(d);
          }
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los comprobantes.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los comprobantes", err);
      }
    },
    launchModal() {
      this.$store.commit("launchModal", {
        title: "Seleccione el Comprobante",
        oktext: "Aceptar",
        canceltext: "Cancelar",
        titleTable: [
          { cod: "codigo", name: "Código" },
          { cod: "nombre", name: "Nombre" },
        ],
        table: this.comprobanteModal,
        result: "c1",
      });
    },
    blurFunction(el) {
      let text = this.textInputs[el];
      if (el === "c1") {
        const indice = text.indexOf(" - ");
        if (text.indexOf(" - ") !== -1) {
          text = text.substr(0, indice);
        }
        const comprobante = functions.findData(
          this.comprobantes,
          text,
          "codigo"
        );
        if (comprobante) {
          const periodo = {
            year: new Date().getFullYear(),
            mes: new Date().getMonth(),
            dia: new Date().getDate(),
          };
          this.textInputs["c3"] = periodo.dia;
          let lengthtextmes = periodo.mes + 1;
          lengthtextmes = lengthtextmes.toString().length;
          if (lengthtextmes === 1) {
            periodo.periodo = `${periodo.year}0${periodo.mes + 1}`;
          } else {
            periodo.periodo = `${periodo.year}${periodo.mes + 1}`;
          }
          if (this.hasBoxOfCash) {
            if (this.turno._id) {
              this.comundata.dia = periodo.dia;
              this.comundata.periodo = periodo.periodo;
              this.textInputs["c3"] = periodo.dia;
              this.editday = false;
              setTimeout(function () {
                document.getElementById("inputItems").focus();
              }, 5);
              this.textInputs[
                el
              ] = `${comprobante.codigo} - ${comprobante.nombre}`;
              this.textInputs["c2"] = `${
                comprobante.prefijo ? comprobante.prefijo : ""
              }${comprobante.consecutivo}`;
              this.comundata.comprobante = comprobante;
              this.comundata.numDoc = comprobante.consecutivo;
            } else {
              // aqui va un error donde diga que primero debe abrir la caja
              this.comundata.comprobante = null;
              this.textInputs[el] = "";
              this.$store.dispatch("notify", {
                message: "Debe abrir la caja primero.",
                type: "is-danger",
                position: "top-center",
              });
            }
          } else {
            if (comprobante.automaticdate) {
              this.comundata.dia = periodo.dia;
              this.comundata.periodo = periodo.periodo;
              this.textInputs["c3"] = periodo.dia;
              this.editday = false;
              setTimeout(function () {
                document.getElementById("inputItems").focus();
              }, 5);
              this.textInputs[
                el
              ] = `${comprobante.codigo} - ${comprobante.nombre}`;
              this.textInputs["c2"] = `${
                comprobante.prefijo ? comprobante.prefijo : ""
              }${comprobante.consecutivo}`;
              this.comundata.comprobante = comprobante;
              this.comundata.numDoc = comprobante.consecutivo;
            } else {
              this.comundata.periodo = this.empresa.mesc;
              this.editday = true;
              this.textInputs[
                el
              ] = `${comprobante.codigo} - ${comprobante.nombre}`;
              this.textInputs["c2"] = `${
                comprobante.prefijo ? comprobante.prefijo : ""
              }${comprobante.consecutivo}`;
              this.comundata.comprobante = comprobante;
              this.comundata.numDoc = comprobante.consecutivo;
            }
          }
          this.tomadatacomprobante();
          const _this = this;
          setTimeout(function () {
            _this.ingresaDataEnItemsEncabezado();
          }, 30);
        } else {
          if (text === "") {
            this.comundata.comprobante = null;
          } else {
            this.comundata.comprobante = null;
            this.textInputs[el] = "";
            this.$store.dispatch("notify", {
              message: "El comprobante no existe.",
              type: "is-warning",
              position: "top-center",
            });
          }
        }
      }
      if (el === "c3") {
        text = parseInt(text);
        if (isNaN(text)) {
          text = 1;
        } else {
          if (text > 31 || text < 1) {
            text = 1;
          }
        }
        this.textInputs["c3"] = text;
        this.comundata.dia = text;
        this.cambio++;
      }
    },
    clicktocashbox() {
      if (this.showmodalcashbox) {
        this.showmodalcashbox = false;
      } else {
        this.showmodalcashbox = true;
      }
    },
  },
  created() {
    this.traeusermongo();
    this.traeComprobantes();
    this.traeCuentas(this);
    this.traeVendedores(this);
    this.traeBodegas(this);
    this.traeNits(this);
    this.traeCCostos(this);
    this.traeProductos(this);
    let temporal = localStorage.getItem("temporal");
    temporal = JSON.parse(temporal);
    if (temporal) {
      this.existborrador = true;
      this.borrador = temporal;
    }
    if (this.hasBoxOfCash) {
      this.findturno();
    }
  },
  watch: {
    compperiodo(nv, ov) {
      if (
        nv.comprobante.nombre !== "Comprobantes" &&
        nv.periodo.codigo !== "Meses"
      ) {
        this.traeDocumentos(this, nv.comprobante.id, nv.periodo.codigo);
      }
    },
    isNCElect(nv, ov) {
      if (nv) {
        this.traeMeses(this);
      }
    },
    async resultDatamodal(newv, oldv) {
      if (newv.result) {
        if (newv.result.substr(0, 1) === "c") {
          // esto es si el resultado del modal es el encabezado del registro ejecute algo
          if (newv.result.substr(1, 1) === "1") {
            this.textInputs.c1 = newv.data[newv.title[0].cod];
            document.getElementById(newv.result).focus();
          }
        }

        if (newv.result === "nits") {
          this.itemsencabezado[0].input = newv.data.codigo;
          this.itemsencabezado[0].inputrich = newv.data.nombre;
          this.itemsencabezado[0].inputid = newv.data.id;
          this.cambio++;
        }
        if (newv.result === "vendedor") {
          this.itemsencabezado[2].input = newv.data.codigo;
          this.itemsencabezado[2].inputrich = newv.data.nombre;
          this.itemsencabezado[2].inputid = newv.data.id;
          this.cambio++;
        }
        if (newv.result === "lprecios") {
          this.itemsencabezado[4].input = newv.data.codigo;
          this.itemsencabezado[4].inputrich = newv.data.nombre;
          this.itemsencabezado[4].inputid = newv.data.id;
          this.cambio++;
        }
        if (newv.result === "fpago") {
          this.itemsencabezado[3].input = newv.data.codigo;
          this.itemsencabezado[3].inputrich = newv.data.nombre;
          this.itemsencabezado[3].inputid = newv.data.id;
          this.cambio++;
        }
        if (newv.result === "ccostos") {
          this.itemsencabezado[5].input = newv.data.codigo;
          this.itemsencabezado[5].inputrich = newv.data.nombre;
          this.itemsencabezado[5].inputid = newv.data.id;
          this.cambio++;
        }
        if (newv.result === "cotizacion") {
          try {
            const doc = newv.data.documento;
            const mes = newv.data.mes;
            const year = newv.data.year;
            const comprobante = newv.data.comprobante;
            this.itemsencabezado[1].input = `${doc}-${year}-${mes}`;
            this.cambio++;
            const result = await apiServices.get(
              `/findregcotizaciones/${doc}/${year}/${mes}/${comprobante}`
            );
            if (result.data) {
              const registros = result.data;
              this.cargaregistros(registros);
            }
          } catch (err) {
            this.$store.dispatch("notify", {
              message: "Ocurrió un error cargando los registros.",
              type: "is-danger",
              position: "top-center",
            });
            console.log(err);
          }
        }
        if (this.fila > -1) {
          const _this = this;
          const keysitems = [];
          for (let index in this.productosfactura[this.fila].items) {
            keysitems.push(_this.productosfactura[this.fila].items[index].cod);
          }
          const nbodega = keysitems.indexOf("nbodega");
          const nbatch = keysitems.indexOf("batchcodigo");
          if (newv.result === "producto") {
            this.productosfactura[this.fila].items[0].input = newv.data.codigo;
            this.productosfactura[this.fila].items[0].inputrich =
              newv.data.nombre;
            this.productosfactura[this.fila].items[0].inputid = newv.data.id;
            this.cambio++;
          }
          if (newv.result === "bodega") {
            this.productosfactura[this.fila].items[nbodega].input =
              newv.data.codigo;
            this.productosfactura[this.fila].items[nbodega].inputrich =
              newv.data.nombre;
            this.productosfactura[this.fila].items[nbodega].inputid =
              newv.data.id;
            this.cambio++;
          }
          if (newv.result === "batch") {
            this.productosfactura[this.fila].items[nbatch].input =
              newv.data.codigo;
            this.productosfactura[this.fila].items[nbatch].inputrich =
              newv.data.nombre;
            this.productosfactura[this.fila].items[nbatch].inputid =
              newv.data.id;
            this.cambio++;
          }
        }
      }
    },
    columna(nv, ov) {
      const temporal = {
        comprobante: this.comundata.comprobante,
        dia: this.comundata.dia,
        documento: this.comundata.numDoc,
        registros: this.registros,
        encabezado: this.encabezadoFactura,
        contrapartida: this.contrapartida,
        productosfactura: this.productosfactura,
        totalesfactura: this.totalesfactura,
      };
      if (temporal.productosfactura.length > 0) {
        localStorage.setItem("temporal", JSON.stringify(temporal));
      }
      if (this.fila === -1) {
        this.validaencabezado(ov);
        if (ov === 1 && this.encabezadoFactura.idnit === null) {
          this.$store.commit("launchModalnit", this.itemsencabezado[0].input);
          this.columna = 1;
        }
      } else {
        this.validaregistros(ov);
      }
    },
    empresa(nv, ov) {
      if (ov._id !== "no id") {
        if (ov._id !== nv._id) {
          this.cancelar();
          if (this.hasBoxOfCash) {
            this.findturno();
          }
        }
      }
    },
  },
  components: {
    yItemsform,
    yItemsview,
    yItemsview2,
    yModalcashback,
    yModalcashbox,
    yPrintfrapvta,
    yPrintfrapvtastrip,
    yPrintfrapvtastrip80,
    yFormregistrototal,
  },
};
</script>

<style lang="scss" scoped>
.etiqutaE {
  font-size: 12px;
  margin-top: -24px;
  margin-left: -16px;
  position: absolute;
  background-color: #b5b5b5;
  padding: 1px 5px 1px 5px;
  border-radius: 2px;
  color: white;
}
.etiqutaR {
  font-size: 11px;
  margin-top: -16px;
  margin-left: -16px;
  position: absolute;
  background-color: #b5b5b5;
  padding: 0 5px 0 5px;
  border-radius: 2px;
  color: white;
}
.cashboxbutton {
  bottom: 15px;
  position: fixed;
  z-index: 38;
  right: 15px;
  box-shadow: 5px 0px 13px 3px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}
.notification {
  padding: 15px;
  margin-bottom: 5px;
}
.selected {
  background-color: #f5f5f5e3;
  box-shadow: 0px 3px 6px #c9c9c9;
}
.datospruducto {
  table,
  td,
  th {
    font-size: 14px;
    // border: 1px solid #eeeeee !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
    color: #ffffff !important;
  }

  tfoot {
    border: 0px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/facturar/Nuevafactura.vue